import { debounce, get } from "lodash"
import PropTypes from "prop-types"
import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import { compose, lifecycle, withHandlers, withState } from "recompose"
import { Message, List, Loader, Pagination } from "semantic-ui-react"
import { OrganizationsApiService } from "./../../api"

const { Content, Description, Header, Item } = List

const Registries = ({ activePage, isLoading, match, onPageChange, registries, totalPages }) => (
	<Fragment>
		{isLoading ? (
			<Loader active={true} content="Ładowanie danych..." inline="centered" />
		) : registries.length > 0 ? (
			<List animated divided relaxed="very">
				{registries.map(({ lastSynchronized, name, registryId }) => (
					<Item as={Link} key={registryId} to={`${match.url}/${registryId}`}>
						<Content>
							<Header>{name}</Header>
							<Description>Data synchronizacji: {lastSynchronized}</Description>
						</Content>
					</Item>
				))}
			</List>
		) : (
			<Message
				content="Nie znaleziono rejestrów przypisanych do tego urzędu."
				header="Brak wyników"
				icon="frown"
			/>
		)}
		{totalPages > 1 && (
			<Pagination
				activePage={activePage}
				onPageChange={onPageChange}
				totalPages={totalPages}
			/>
		)}
	</Fragment>
)

Registries.propTypes = {
	activePage: PropTypes.number,
	isLoading: PropTypes.bool,
	match: PropTypes.object.isRequired,
	onPageChange: PropTypes.func,
	totalPages: PropTypes.number,
	registries: PropTypes.array
}

Registries.defaultProps = {
	activePage: 1,
	registries: [],
	onPageChange: () => {},
	totalPages: 1
}

const enhance = compose(
	withState("activePage", "setActivePage", 1),
	withState("registries", "setRegistries", []),
	withState("isLoading", "setLoading", true),
	withState("totalPages", "setTotalPages", 1),
	withHandlers({
		onLoadRegistries: ({
			activePage,
			match,
			setLoading,
			setRegistries,
			setTotalPages
		}) => async () => {
			const debouncedSetLoading = debounce(setLoading, 300)
			debouncedSetLoading(true)
			try {
				const organizationId = get(match, "params.organization")
				const { registries, totalCount } = await OrganizationsApiService.getRegistries(
					organizationId,
					activePage - 1
				)
				setRegistries(registries)
				const totalPages = Math.ceil(totalCount / registries.length)
				setTotalPages(totalPages)
			} finally {
				debouncedSetLoading.cancel()
				setLoading(false)
			}
		}
	}),
	withHandlers({
		onPageChange: ({ setActivePage, onLoadRegistries }) => async (e, { activePage }) => {
			await setActivePage(activePage)
			onLoadRegistries()
		}
	}),
	lifecycle({
		async componentDidMount() {
			this.props.onLoadRegistries()
		}
	})
)

export default enhance(Registries)



// WEBPACK FOOTER //
// ./src/containers/registries/Registries.js